﻿class Html5VideoControls{
     
    constructor(){
    }
     bindAllVideos(){
         const videoButtons = document.querySelectorAll('.js-video-playpause-btn');
         if(videoButtons.length>0){
             for (let aVideoButton of videoButtons) {
                 const videoButtonId = aVideoButton.id;
                 const videoId = aVideoButton.nextElementSibling.id;
                 this.bindAVideo(videoButtonId, videoId);
             }
         }
        
    }

    bindAVideo(buttonId, videoId){
        this.videoButton = document.getElementById(buttonId);
        this.videoElement = document.getElementById(videoId);
        this.registerEvents();
    }

    registerEvents(){
        this.videoElement.addEventListener('pause', ()=>{
            this.videoButton = event.currentTarget.previousElementSibling;
            this.showButton();
        });
        this.videoElement.addEventListener('play', (event)=>{
            this.videoButton = event.currentTarget.previousElementSibling;
            this.hideButton();
        });
        this.videoButton.addEventListener('click', (event)=>{
            event.stopPropagation();
            this.videoButton = event.currentTarget;
            this.videoElement = event.currentTarget.nextElementSibling;
            this.playPause();
        });
    }

    playPause(){
        if (this.videoElement.paused){
            this.videoElement.play();
            this.hideButton();
        }else{
            this.videoElement.pause();
            this.showButton();
        }
    }

    showButton(){
        if(!!this.videoButton){
            this.videoButton.style.display = 'block';
        }
    }

    hideButton(){
        this.videoButton.style.display = 'none';
    }
}
  
export default Html5VideoControls; 
